import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TERMS_SECTIONS, PRIVACY_SECTIONS, TOS_VERSION, PRIVACY_VERSION } from "../lib/legal";
import Seo from "../components/Seo";

function LegalPageShell({ title, version, sections, testId, path, seoTitle, seoDescription }) {
  return (
    <div className="grain-bg min-h-screen bg-zinc-950 text-white p-6 md:p-12" data-testid={testId}>
      <Seo path={path} title={seoTitle} description={seoDescription} />
      <div className="max-w-3xl mx-auto pt-8 md:pt-16">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-3 h-3" /> Back
        </Link>
        <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-3">
          Version {version}
        </div>
        <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tighter mb-10">
          {title}
        </h1>
        <div className="space-y-8">
          {sections.map((s) => (
            <section key={s.title}>
              <h2 className="text-lg font-semibold text-white mb-2">{s.title}</h2>
              <p className="text-sm leading-relaxed text-zinc-400">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export function TermsPage() {
  return <LegalPageShell title="Terms of Service" version={TOS_VERSION} sections={TERMS_SECTIONS} testId="terms-page" path="/terms" seoTitle="Terms of Service" seoDescription="LinguaSub terms of service — what LinguaSub does, your rights, acceptable use, and takedown policy." />;
}
export function PrivacyPage() {
  return <LegalPageShell title="Privacy Policy" version={PRIVACY_VERSION} sections={PRIVACY_SECTIONS} testId="privacy-page" path="/privacy" seoTitle="Privacy Policy" seoDescription="LinguaSub privacy policy — what data we collect, 48-hour media retention, third-party processors, and your rights." />;
}
